import {
  TRANSACTIONS_SORT_KEYS,
  TRANSACTIONS_SORT_TYPES,
  transactionsQuickFilterConstants,
  sortKeys,
} from '../../pages/Transactions/transactionsConstants';
import {
  getFilterPayloadValues,
  getLocalDateFilterValue,
  isDateWithinRange,
} from '../../helpers/filterDate';
import { sortItemsByConfig } from '../../helpers/tableSort';
import * as types from './transactionActionTypes';

const initialState = {
  transactions: null,
  filteredTransactions: null,
  transactionsSortData: {
    sortType: TRANSACTIONS_SORT_TYPES.DESCENDING,
    sortKey: TRANSACTIONS_SORT_KEYS.CREATE_DATE,
  },
  quickFilter: 1,
  error: {
    type: null,
    data: null,
  },
};

export const transactionReducer = (state = initialState, action) => {
  const sortTransactionsByCurrentSort = (
    transactions = [],
    sortData = state.transactionsSortData
  ) => sortItemsByConfig(
    transactions,
    sortData,
    sortKeys,
    TRANSACTIONS_SORT_TYPES.ASCENDING
  );

  switch (action.type) {
    case types.GET_TRANSACTIONS_DATA:
      let transactions = action.payload.result
      return {
        ...state,
        transactions: transactions ? sortTransactionsByCurrentSort(transactions) : null,
      };

    case types.GET_TRANSACTIONS_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_TRANSACTIONS_ERROR,
          data: action.payload,
        },
      };
    case types.FILTER_TRANSACTIONS:
      function filterTransactions(payload) {
        const { searchText, startDate, endDate, actionValue } = getFilterPayloadValues(payload);
        const filteredTransactions = [];

        let tempTransactionsForFilter = state.transactions;

        if (state.quickFilter === transactionsQuickFilterConstants.TRUE) {
          tempTransactionsForFilter = tempTransactionsForFilter.filter(
            (t) => t.transaction_status === true);
        } else if (state.quickFilter === transactionsQuickFilterConstants.FALSE) {
          tempTransactionsForFilter = tempTransactionsForFilter.filter(
            (t) => t.transaction_status === false);
        }


        if (tempTransactionsForFilter) {
          for (const fTransactions of tempTransactionsForFilter) {
            const matchesSearch = !searchText ||
              fTransactions?.transaction_hash?.toString().toLowerCase().includes(searchText) ||
              fTransactions?.project_name?.toString().toLowerCase().includes(searchText) ||
              fTransactions?.token_address?.toString().toLowerCase().includes(searchText) ||
              fTransactions?.user_public_address?.toString().toLowerCase().includes(searchText);
            const transactionDate = getLocalDateFilterValue(
              fTransactions?.cdate || fTransactions?.transaction_time
            );
            const matchesDate = isDateWithinRange(transactionDate, startDate, endDate);
            const matchesAction = !actionValue ||
              fTransactions?.action?.toString().toLowerCase() === actionValue;

            if (
              matchesSearch &&
              matchesDate &&
              matchesAction
            ) {
              filteredTransactions.push(fTransactions);
            }
          }

          return filteredTransactions;
        }
      }

      let filteredTransactions = null;
      filteredTransactions = filterTransactions(action?.payload);

      return {
        ...state,
        filteredTransactions: filteredTransactions ? [...filteredTransactions] : null,
      };
    case types.SET_TRANSACTIONS_SORT_DATA:
      return {
        ...state,
        transactionsSortData: { ...action.payload },
      };
    case types.SORT_TRANSACTIONS:
      const tempTransactionsForSorting = state.filteredTransactions?.length
        ? state.filteredTransactions
        : state.transactions;
      const sortedTransactions = sortTransactionsByCurrentSort(tempTransactionsForSorting);

      if (state.filteredTransactions?.length) {
        return {
          ...state,
          filteredTransactions: sortedTransactions ? [...sortedTransactions] : null,
        };
      }
      return {
        ...state,
        transactions: sortedTransactions ? [...sortedTransactions] : state.transactions,
      };

    case types.UPDATE_QUICK_FILTER:
      return {
        ...state,
        quickFilter: action?.payload,
      };
    default:
      return state;
  }
};
